import { useState, useEffect } from 'react';
import { handleLogout } from '../core/services/APIservice';
import { LOGOUT_REDIRECTION_ENDPOINT, AUTH_KEY, APP_URLS, NOT_AUTHORIZED_ERROR } from './constants'
import { CURRENCIES } from './messages';
import crypto from "crypto"

// TODO: Simplyfy the method names and refactor the unused methods
// Storage Utils
export const saveKeyToLocalStorage = (key: string, value: string) => {
  if (typeof window === 'undefined') return
  return window.localStorage.setItem(key, value);
}

export const getValueFromLocalStorage = (key: string) => {
  if (typeof window === 'undefined') return
  const result = window.localStorage.getItem(key)
  if (!!result && result !== undefined) {
    return result
  }
  return undefined
}

export const replaceValueFromLocalStorage = (key: string, value: string) => {
  if (typeof window === 'undefined') return
  return window.localStorage.setItem(key, value)
}

export const setStorage = (key: string, value: any) => {
  if (typeof window === 'undefined') return
  window['sessionStorage'].setItem(key, value)
}

export const getStorage = (key: string) => {
  if (typeof window === 'undefined') return

  const result = window['sessionStorage'].getItem(key)
  if (!!result && result !== undefined) {
    return JSON.parse(result)
  }

  return undefined
}

export const removeItemFromLocalStorage = (key: string) => {
  return localStorage.removeItem(key)
}

export const getTransactionIdFromURL = () => {
  let txnId = window.location.pathname.split("/")
  return txnId[txnId.length - 1]
}

export const clearStorage = () => {
  window.localStorage.clear()
  window.sessionStorage.clear()
}


// Application utils
export const isCommonErrorPage = () => {
  return window.location.pathname === APP_URLS.COMMON_ERROR
}
export const isErrorPage = () => {
  return window.location.pathname.includes(APP_URLS.COMMON_ERROR)
}


// Messages Utils
export const amountWithCommas = (amount: number) => {
  if (amount === undefined || amount === null) {
    return ""
  }
  let amt = amount.toString().split('.')
  var netAmount = amt[0]
  let amountDecimal = amt[1]
  return netAmount.toString().split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",").concat(`${amountDecimal ? '.' + amountDecimal.slice(0,2) : ''}`)
}

export const capitalize = (input: string) => {
  if (input === undefined) {
    return ""
  }
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export const amountWithCurrencyWithoutComma = (currency: string, amount: number) => {
  switch (currency) {
    case CURRENCIES.USD:
      return "$" + amount
    case CURRENCIES.INR:
      return "₹" + amount
  }
}

export const amountWithCurrencyAndComma = (currency: string, amount: number) => {
  switch (currency) {
    case CURRENCIES.USD:
      return "$" + amountWithCommas(amount)
    case CURRENCIES.INR:
      return "₹" + amountWithCommas(amount)
  }
}

export const padStart = (input: string | number, decimal: number) => {
  return String(input).padStart(decimal, '0')
}

export const resetInput = () => {
  return Math.random().toString(36);
}

export function trimFileName(fileName: string) {
  var delimiter = fileName.lastIndexOf('.'),
    extension = fileName.substr(delimiter),
    file = fileName.substr(0, delimiter);

  var filenameLen = 25;
  return (file.length > filenameLen ? file.substr(0, filenameLen) + "..." : file) + extension;
}

// Encrypt Utils

export const crypt = (value:any , transactionId:any) => {
    const iv = crypto.randomBytes(16);
    const salt = crypto.randomBytes(20);
    const key = crypto.pbkdf2Sync(transactionId ,salt,50, 16, 'sha1');
    const cipher = crypto.createCipheriv('aes-128-cbc', key, iv);
    const encrypted = Buffer.concat([cipher.update(value , 'utf8'), cipher.final()]);
    return Buffer.concat([salt, iv, encrypted]).toString('base64');
}

export const decrypt = (encryptedText:any, keySecret:any)=> {
  let salt = Buffer.from(encryptedText, 'base64').slice(0,20);
  let key = crypto.pbkdf2Sync(keySecret ,salt,50, 16, 'sha1');
  let iv = Buffer.from(encryptedText, 'base64').slice(20,36);
  let encryptedBuffer = Buffer.from(encryptedText, 'base64').slice(36,);
  let decipher = crypto.createDecipheriv('aes-128-cbc', key, iv);
  let decrypted = decipher.update(encryptedBuffer);
  decrypted = Buffer.concat([decrypted, decipher.final()]);
  return decrypted.toString();
}

export const gaEncrypt = (key:any, content:any) => {
  const encryptionKeyBuf = Buffer.from(key, 'hex');
  const keySizeBits = encryptionKeyBuf.length * 8;
  const aesAlgorithm = `AES-${keySizeBits}-ECB`;
  const ivBuf = Buffer.alloc(0);
  const cipher = crypto.createCipheriv(aesAlgorithm, encryptionKeyBuf, ivBuf);

  return [cipher.update(content, 'utf8', 'hex'), cipher.final('hex')]
    .join('')
    .toUpperCase();
};

// Screen Utils
const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

// Auth Utlis

// TODO: Remove unused Util methods
const redirectTo = (path: string) => {
  clearStorage()
  return window.location.assign(path)
}

const logout = () => {
  return handleLogout().then((res) => {
    if (res.status === 200) {
      clearStorage()
    } else {
      throw NOT_AUTHORIZED_ERROR
    }
  }).catch((_err) => {
    redirectTo(APP_URLS.COMMON_ERROR)
  })
}

const logoutAndRedirectTo = (url: string) => {
  return logout().then(() => {
    redirectTo(url)
  })
}

const logoutUser = (url = LOGOUT_REDIRECTION_ENDPOINT) => logoutAndRedirectTo(url)

const forcedLogoutUser = () => logoutAndRedirectTo(LOGOUT_REDIRECTION_ENDPOINT)

const endSessionAndRedirect = (path: string) => {
  clearStorage()
  redirectTo(path)
}

const isUserLoggedIn = (txnId: string) => {
  return Boolean(getValueFromLocalStorage(AUTH_KEY(txnId)))
}

function handleUnauthorized(path: string) {
  clearStorage()
  return redirectTo(path)
}

const getAuthorizedHeaders = () => {
  let txnId = getTransactionIdFromURL()
  let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
  let authorizedHeader = {
    Authorization: `Bearer ${authKey}`,
    "x-custom-txn-id": txnId
  }
  return authorizedHeader;
}

export { logoutUser, forcedLogoutUser, isUserLoggedIn, handleUnauthorized, endSessionAndRedirect, getAuthorizedHeaders }
